export const ANALYTICS_CONSENT_KEY = "myelina.cookie-consent";
export const ANALYTICS_CONSENT_EVENT = "myelina:analytics-consent-changed";

export type AnalyticsConsentStatus = "accepted" | "essential-only" | null;

export function getAnalyticsConsent(
  storage: Pick<Storage, "getItem"> | null = typeof window === "undefined" ? null : window.localStorage,
): AnalyticsConsentStatus {
  if (!storage) return null;
  try {
    const value = storage.getItem(ANALYTICS_CONSENT_KEY);
    return value === "accepted" || value === "essential-only" ? value : null;
  } catch {
    return null;
  }
}

export function hasAnalyticsConsent(
  storage: Pick<Storage, "getItem"> | null = typeof window === "undefined" ? null : window.localStorage,
): boolean {
  return getAnalyticsConsent(storage) === "accepted";
}
